import { useAppStructure } from "@redux/features/appStructure/useAppStructure"
import { ModuleNameSOP } from "@routes/clients.$clientName/_sopPageLayout"
import { Link, useLocation } from "@tanstack/react-router"
import { CDN_URL, LOGOS_PATH } from "@utils/cdn"
import { FC } from "react"
import { usePageLayoutContext } from "../layoutContext"

export const DipaiLogoHeader = ({
	isExpanded,
	selectedModule,
	width = 180,
}: {
	isExpanded: boolean
	selectedModule: string
	width?: number
}) => {
	return (
		<div
			className={`w-39.5 ${
				isExpanded === false ? `delay-500 sm:w-15` : `delay-0 duration-0 sm:w-45`
			} border-b-dipai-secondary-901/40 relative flex h-13 items-center border-b-1 pl-4.5 ${
				selectedModule.toLowerCase() !== `fleet overview`
					? `shadow-[0px_1.5px_1px_hsla(0,0%,100%,0.15)]`
					: `shadow-[0px_1.5px_1px_hsla(0,0%,0%,0.15)]`
			}`}
			style={{ width: width }}
		>
			<img
				className={`h-[32.5px]`}
				alt={"D"}
				src={`${CDN_URL}/${LOGOS_PATH}/dipai_logo_d_white.svg`}
			/>
			<img
				className={`h-[32.5px] origin-left transition-all duration-300 ${
					isExpanded === true ? `w-[59.75px] opacity-100` : `w-0 opacity-0`
				}`}
				alt={"ipai"}
				src={`${CDN_URL}/${LOGOS_PATH}/dipai_logo_ipai_white.svg`}
			/>
			<img
				className={`absolute h-[32.5px] transition-all duration-300 ${
					isExpanded === true
						? `left-[calc(21.9px+18px+59.75px)]`
						: `left-[calc(21.9px+18px)]`
				}`}
				alt={"."}
				src={`${CDN_URL}/${LOGOS_PATH}/dipai_logo_dot_yellow.svg`}
			/>
		</div>
	)
}
export const MainNavHeader: FC = () => {
	const location = useLocation()
	const { data: appStructure } = useAppStructure()
	const selectedModule = useLocation().pathname.split("/").at(-1) as ModuleNameSOP

	const {
		isMainNavExpanded,
		isMainNavPopupExpanded,
		isSecondaryNavExpanded,
		setIsMainNavPopupExpanded,
	} = usePageLayoutContext()

	return (
		<>
			<div className={`hidden w-full lg:flex`}>
				{location.pathname.includes("/clients") === true &&
				appStructure != null &&
				Object.keys(appStructure)[0] === "Dipai" ? (
					<Link to={"/clients"}>
						<DipaiLogoHeader
							selectedModule={selectedModule}
							isExpanded={isMainNavExpanded}
						/>
					</Link>
				) : (
					<DipaiLogoHeader
						selectedModule={selectedModule}
						isExpanded={isMainNavExpanded}
					/>
				)}
			</div>
			<div className={`flex w-full sm:flex lg:hidden`}>
				{location.pathname.includes("/clients") === true &&
				appStructure != null &&
				Object.keys(appStructure)[0] === "Dipai" ? (
					<Link to={"/clients"}>
						<DipaiLogoHeader
							selectedModule={selectedModule}
							isExpanded={isMainNavPopupExpanded}
						/>
					</Link>
				) : (
					<DipaiLogoHeader
						selectedModule={selectedModule}
						isExpanded={isMainNavPopupExpanded}
					/>
				)}
			</div>
			{/* <div className={`flex w-full sm:hidden`}>
				{location.pathname.includes("/clients") === true &&
				appStructure !== null &&
				Object.keys(appStructure)[0] === "Dipai" ? (
					<div
						className={`flex origin-left flex-row items-center transition-[width] duration-300 ${
							isSecondaryNavExpanded === true ? "w-53" : "w-13"
						}`}
					>
						<MdMenu
							onClick={() => {
								setIsMainNavPopupExpanded(true)
							}}
							className={`mx-2 h-9 w-9 cursor-pointer rounded-sm px-1 text-white/60 hover:bg-white/10 hover:text-white/100`}
						/>
						{isSecondaryNavExpanded === true ? (
							<Link to={"/clients"}>
								<div className={``}>
									<DipaiLogoHeader
										selectedModule={selectedModule}
										isExpanded={isSecondaryNavExpanded}
									/>
								</div>
							</Link>
						) : null}
					</div>
				) : (
					<div className={`flex flex-row items-center`}>
						<MdMenu
							className={`h-8 w-8 text-white hover:bg-white/10`}
							onClick={() => {
								setIsMainNavPopupExpanded(true)
							}}
						/>
						<DipaiLogoHeader
							selectedModule={selectedModule}
							isExpanded={isSecondaryNavExpanded}
						/>
					</div>
				)}
			</div> */}
		</>
	)
}
